import React from 'react';
import Row from '@amzn/meridian/row';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Button from '@amzn/meridian/button';
import { FormattedMessage, useIntl } from 'react-intl';

interface HideCustomerCommentModalProps {
  open?: boolean;
  onModalClose?(): any;
  onModalConfirm?(): any;
  clickstreamTags: object;
  contactId: string;
}

const HideCustomerCommentModal = ({
  open,
  onModalClose,
  onModalConfirm,
  contactId,
  clickstreamTags,
}: HideCustomerCommentModalProps) => {
  const intl = useIntl();
  const modalId = `hide-customer-comment-modal-${contactId}`;
  const confirmationButtonId = `${modalId}-confirmation-button`;
  const closeButtonId = `${modalId}-close-button`;

  const confirmationButtonClickStreamTags = {
    ...clickstreamTags,
    'data-csa-c-type': 'button',
    'data-csa-c-slot-id':
      'dashboard-table-contact-customer-comments-hide-customer-comment-modal-confirmation-button-slot',
    'data-csa-c-content-id': `dashboard-table-contact-customer-comments-hide-customer-comment-modal-confirmation-button-${contactId}`,
  };

  const closeButtonClickStreamTags = {
    ...clickstreamTags,
    'data-csa-c-type': 'button',
    'data-csa-c-slot-id':
      'dashboard-table-contact-customer-comments-hide-customer-comment-modal-close-button-slot',
    'data-csa-c-content-id': `dashboard-table-contact-customer-comments-hide-customer-comment-modal-close-button-${contactId}`,
  };
  return (
    <Modal
      data-testid={modalId}
      data-cy={modalId}
      title={intl.formatMessage({
        id: 'cs_perfportal_hide_customer_comment_modal_title',
        defaultMessage: 'Hide Customer Comment',
      })}
      open={open!}
      onClose={onModalClose}
      scrollContainer='viewport'
      closeLabel='Close'
      aria-describedby='modal-description'
      width={750}
    >
      <Column>
        <Text id='modal-warning'>
          <FormattedMessage
            id='cs_perfportal_hide_customer_comment_modal_prompt'
            defaultMessage='Are you sure you want to hide customer comment on contact ID {contactId}?'
            values={{ contactId }}
          />
        </Text>
      </Column>
      <ModalFooter>
        <Row alignmentHorizontal='end' widths='fit'>
          <Button
            type='secondary'
            size='medium'
            onClick={onModalClose}
            id={closeButtonId}
            data-cy={closeButtonId}
            data-testid={closeButtonId}
            {...closeButtonClickStreamTags}
          >
            <FormattedMessage id='cs_perfportal_no' defaultMessage='No' />
          </Button>
          <Button
            type='primary'
            size='medium'
            onClick={onModalConfirm}
            id={confirmationButtonId}
            data-cy={confirmationButtonId}
            data-testid={confirmationButtonId}
            {...confirmationButtonClickStreamTags}
          >
            <FormattedMessage id='cs_perfportal_yes' defaultMessage='Yes' />
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default HideCustomerCommentModal;
